import type { IModuloTarea } from "./entidades/IModuloTarea";
import { type IRespuestaApiLista, type IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";
import type { IModulosTarea } from "./entidades/IModulosTarea";

export class ModuloTareaModelo {
    

    constructor() { }
    public async obtenerListaModulosTarea(tareaId: number): Promise<IRespuestaApiLista<IModuloTarea>> {
        const { data } = await api.get(
            `/api/ModuloTareas/ListarPorTarea`, {
            headers: {
                "Content-Type": "application/json"
            },
            params: { tareaId }
        });
        return data;
    }

    public async crearModuloTarea(ModuloTarea: IModuloTarea): Promise<IRespuestaApiObjeto<IModuloTarea>> {
        const { data } = await api.post(
            `/api/ModuloTareas/Crear`, ModuloTarea, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async crearModulosTarea(ModulosTarea: IModulosTarea): Promise<IRespuestaApiObjeto<IModuloTarea>> {
        const { data } = await api.post(
            `/api/ModuloTareas/CrearModulosPorTarea`, ModulosTarea, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    public async actualizarModulosTarea(ModulosTarea: IModulosTarea): Promise<IRespuestaApiObjeto<IModuloTarea>> {
        const { data } = await api.put(
            `/api/ModuloTareas/ActualizarModulosPorTarea`, ModulosTarea, {
            headers: {
                "Content-Type": "application/json"

            },
        });
        return data;
    }

    // public async editarModuloTarea(ModuloTarea: IModuloTarea): Promise<IRespuestaApiObjeto<IModuloTarea>> {
    //     const { data } = await api.put(
    //         `/api/ModuloTareaChecklist/Actualizar`, ModuloTarea, {
    //         headers: {
    //             "Content-Type": "application/json"

    //         },
    //     });
    //     return data;
    // }

    // public async eliminarModuloTarea(ModuloTarea: IModuloTarea): Promise<IRespuestaApiObjeto<IModuloTarea>> {
    //     const { data } = await api.delete(
    //         `/api/ModuloTareaChecklist/Actualizar/${ModuloTarea.Id}`, {
    //         headers: {
    //             "Content-Type": "application/json"

    //         },
    //     });
    //     return data;
    // }

}

